import { CloseRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';

type Props = {
  label: string;
  disabled?: boolean;
  onClick: () => void;
};

const styles = {
  button: {
    alignSelf: 'center',
    color: 'text.secondary',
    flexShrink: 0,
  },
} as const;

const RemoveExclusionButton = ({ label, onClick, disabled }: Props) => (
  <IconButton disabled={disabled} size='small' aria-label={label} onClick={onClick} sx={styles.button}>
    <CloseRounded fontSize='small' />
  </IconButton>
);

export default RemoveExclusionButton;
